import React, { FC, useState } from 'react'
import styles from './InvoiceModal.module.css'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../redux/store'
import {
  fetchAddInvoice,
  setCurrentInvoice,
  setIsVisibleCreateModalInvoice,
  upsertCreatedInvoiceInStore,
} from '../../../redux/reducers/invoices'
import { formatDateToDDMMYYYY } from '../../../utils/date'
import { getAmount, getItemCurrency } from '../../../utils/getAmount'
import {
  Cargo,
  removeCargosFromStore,
  setCargosGroup,
  setCurrentCargo,
} from '../../../redux/reducers/cargos'
import { cargosSelector } from '../../../redux/selectors/cargos-selector'
import { getFiltersFromSessionStorage } from '../../../utils/filterUtils'

interface Props {
  selectedCargos: number[]
  setSelectedCargos: any
}
const InvoiceCreateModal: FC<Props> = ({
  selectedCargos,
  setSelectedCargos,
}) => {
  const dispatch = useDispatch<AppDispatch>()
  const { currentCargoGroup } = useSelector(cargosSelector)

  const chooseCargos = currentCargoGroup?.filter((item) =>
    selectedCargos.includes(item.id)
  )

  const [date, setDate] = useState('')

  const handleSave = () => {
    dispatch(fetchAddInvoice({ selectedCargos, date })).then((res) => {
      //@ts-ignore
      if (!res.error) {
        const createdInvoice = res.payload
        const filters = getFiltersFromSessionStorage()
        const rawFilter = sessionStorage.getItem('accountsFilter')
        const parsedRawFilter = rawFilter ? JSON.parse(rawFilter) : null
        const isClientNotSelectedInFilter =
          parsedRawFilter &&
          Object.prototype.hasOwnProperty.call(parsedRawFilter, 'clientId') &&
          (parsedRawFilter.clientId === null || parsedRawFilter.clientId === '')

        dispatch(removeCargosFromStore({ cargoIds: selectedCargos }))
        if (!isClientNotSelectedInFilter) {
          dispatch(
            upsertCreatedInvoiceInStore({
              invoice: createdInvoice,
              filters,
            })
          )
        }

        dispatch(setIsVisibleCreateModalInvoice(false))
        setSelectedCargos([])
        dispatch(setCargosGroup(null))
        dispatch(setCurrentCargo(null))
      }
    })
  }
  const totalAmount = chooseCargos?.reduce(
    (sum, cargo) => sum + (cargo.amount || 0),
    0
  )

  const getCounterpartyInfo = (cargo: Cargo) => {
    if (cargo.payer === 1) {
      return `${cargo.from.entity_name} ⊳`
    }
    return `⊳ ${cargo.to.entity_name}`
  }

  return (
    <div style={{ display: 'block' }} className={styles.win}>
      <div className={styles.winContainer}>
        <div className={styles.winContent}>
          <div
            onClick={() => {
              dispatch(setCurrentInvoice(null))
              dispatch(setIsVisibleCreateModalInvoice(false))
              setSelectedCargos([])
              dispatch(setCargosGroup(null))
              dispatch(setCurrentCargo(null))
            }}
            className={styles.close}
          >
            ×
          </div>
          <div className={styles.winContentFulltext}>
            <div className="mb-3 pl-5 pr-5" style={{ textAlign: 'center' }}>
              <div className="mb-2">
                <b>
                  {chooseCargos?.[0]?.from?.entity_name
                    ? chooseCargos[0].from.entity_name
                    : chooseCargos?.[0]?.from.name}
                </b>
              </div>
              <h3 style={{ textAlign: 'center' }} className="mb-1">
                Новый счёт
              </h3>
            </div>

            <div
              className={classNames(
                'row align-items-center mb-3',
                styles.small
              )}
            >
              <div className="col-auto pr-1 mb-1" style={{ textAlign: 'left' }}>
                <span
                  style={{ width: '135px' }}
                  className={classNames(
                    'd-block d-sm-inline-block',
                    styles.reportDate
                  )}
                  id="report_date_input_wrapper_invoice"
                >
                  <input
                    className={classNames(
                      styles.calendarInput,
                      styles.dateInput
                    )}
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </span>
              </div>
              <div className="col pb-1" style={{ textAlign: 'left' }}>
                <span className={styles.small3}>На сумму:</span>
                <br></br>
                <b className={styles.colorRed}>
                  {getAmount(totalAmount ?? 0)}{' '}
                  {getItemCurrency(chooseCargos?.[0]?.currency ?? '')}
                </b>
              </div>
            </div>

            {chooseCargos?.map((item) => (
              <div
                className={classNames(
                  styles.shipmentItem,
                  styles.bxShadowSmall,
                  styles.bgGray,
                  styles.border10,
                  styles.small2,
                  'pt-1 pb-1  mb-2'
                )}
              >
                <div className="row align-items-center ml-2 mr-2">
                  <div className="col-12 pl-1">
                    <div className={styles.ellipsis2}>
                      <b>{item.description}</b>
                    </div>
                  </div>
                  <div
                    className={classNames(
                      styles.small2,
                      'col-12 col-sm pt-1 pb-1 pl-1 '
                    )}
                  >
                    <div className={styles.small3}>
                      <i
                        className={classNames(
                          styles.icon,
                          styles.iconRoute,
                          styles.icon10
                        )}
                      ></i>{' '}
                      {item?.report?.number || 'б/н'} &nbsp;{' '}
                      <span className={styles.colorGray}>
                        от {formatDateToDDMMYYYY(item?.report?.departure)}
                      </span>
                    </div>

                    <div className={classNames(styles.small3, 'mb-1')}>
                      {!!item.has_tn && (
                        <span
                          className={classNames(
                            'd-inline-block pl-1 pr-1 mr-1',
                            styles.bgGreen,
                            styles.colorWhite,
                            styles.borderRadius5,
                            styles.small3
                          )}
                        >
                          <b>Т/Н</b>
                        </span>
                      )}
                      {getCounterpartyInfo(item)}
                    </div>
                  </div>
                  <div
                    className="col-auto pl-1 pr-3"
                    style={{ textAlign: 'right' }}
                  >
                    <div className="col-auto pl-1 pr-3">
                      <b className={classNames(styles.colorRed, styles.nowrap)}>
                        {getAmount(item.amount || 0)}{' '}
                        {getItemCurrency(item.currency)}
                      </b>
                    </div>
                  </div>
                  {/* <div
                    className="col col-sm-auto pl-1 pr-0"
                    style={{ textAlign: 'right' }}
                  >
                    <EditButton
                      onClick={() => {
                        dispatch(setIsVisibleModalCargo(true))
                        // dispatch(setCargosGroup(item))
                        // dispatch(setIsVisibleCreateModalInvoice(false))
                        dispatch(setCurrentInvoice(null))
                      }}
                    />
                    <div
                      data-tooltip="Убрать доставку из счёта"
                      className={classNames(
                        styles.btn,
                        styles.btnSmall2,
                        styles.btnIcon,
                        styles.btnOutline,
                        styles.tooltipLeftCenter
                      )}
                    >
                      <i
                        className={classNames(styles.icon, styles.iconRemove)}
                      ></i>
                    </div>
                    <DeleteButton
                      onClick={() => null}
                      // dispatch(setCurrentInvoice(item))
                      // dispatch(setVisibleDeleteModalInvoice(true))}
                    />
                  </div> */}
                </div>
              </div>
            ))}

            <div className="row mt-3">
              <div
                className="col-6 col-sm-6 mt-1 mb-1"
                style={{ textAlign: 'left' }}
              >
                <button
                  onClick={handleSave}
                  disabled={!date}
                  className={classNames(
                    'd-block',
                    'd-sm-inline-block',
                    styles.btn,
                    styles.btnSmall
                  )}
                >
                  <i
                    className={classNames(styles.icon, styles.iconCheckWhite)}
                  ></i>{' '}
                  Сохранить
                </button>
              </div>
              {/* <div
                className="col-auto pl-1 pr-1  mt-1 mb-1"
                style={{ textAlign: 'center' }}
              >
                <div
                  className={classNames(
                    styles.btn,
                    styles.btnSmall,
                    styles.btnBlue
                  )}
                >
                  <i
                    className={classNames(
                      styles.icon,
                      styles.iconDownload,
                      styles.iconWhite
                    )}
                  ></i>{' '}
                  PDF
                </div>
              </div> */}
              <div
                className="col-6 col-sm-6 mt-1 mb-1"
                style={{ textAlign: 'right' }}
              >
                <div
                  onClick={() => {
                    dispatch(setCurrentInvoice(null))
                    dispatch(setIsVisibleCreateModalInvoice(false))
                    setSelectedCargos([])
                    dispatch(setCargosGroup(null))
                    dispatch(setCurrentCargo(null))
                  }}
                  className={classNames(
                    'd-block',
                    'd-sm-inline-block',
                    styles.btn,
                    styles.btnSmall,
                    styles.btnBlueOutline
                  )}
                >
                  Отмена
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvoiceCreateModal
